import Markdown from "markdown-to-jsx";
import { CustomLink } from "../../../utils/helper";
import PropTypes from "prop-types";

// Moved out component definitions
const CustomH1 = ({ children }) => (
  <h1 className="!text-lg !font-semibold my-2">{children}</h1>
);

const CustomH2 = ({ children }) => {
  // Check if heading starts with an emoji
  const emojiMatch = children
    ?.toString()
    .match(
      /^([\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}])/u
    );
  if (emojiMatch) {
    return (
      <h2 className="!text-xl !font-bold my-3 flex items-center gap-2">
        <span className="text-2xl">{emojiMatch[1]}</span>
        <span>
          {children.toString().replace(emojiMatch[1], "").trim()}
        </span>
      </h2>
    );
  }
  return (
    <h2 className="!text-base !font-medium my-2">{children}</h2>
  );
};

const CustomH3 = ({ children }) => (
  <h3 className="text-sm my-2 !font-bold my-3 !text-[19px]">
    {children}
  </h3>
);

const CustomUl = ({ children }) => (
  <ul className="list-disc pl-5 space-y-1 my-2">{children}</ul>
);

const CustomLi = ({ children }) => (
  <li className="!text-sm">{children}</li>
);

const CustomHr = () => <hr className="my-3 border-gray-200" />;

const CustomP = ({ children }) => {
  // Special handling for address lines
  if (
    typeof children === "string" &&
    (children.startsWith("Address:") ||
      children.startsWith("Phone:"))
  ) {
    return <p className="!text-sm my-1">{children}</p>;
  }
  return <p className="!text-sm my-2">{children}</p>;
};

function BotMarkdown({ content }) {
  return (
    <Markdown
      options={{
        overrides: {
          a: { component: CustomLink },
          h1: { component: CustomH1 },
          h2: { component: CustomH2 },
          h3: { component: CustomH3 },
          ul: { component: CustomUl },
          li: { component: CustomLi },
          hr: { component: CustomHr },
          p: { component: CustomP },
        },
      }}
    >
      {content}
    </Markdown>
  );
}

BotMarkdown.propTypes = {
  content: PropTypes.string.isRequired, 
};
CustomH1.propTypes = {
  children: PropTypes.node,
};
CustomH2.propTypes = {
  children: PropTypes.node,
};
CustomH3.propTypes = {
  children: PropTypes.node,
};
CustomUl.propTypes = {
  children: PropTypes.node,
};
CustomLi.propTypes = {
  children: PropTypes.node,
};
CustomP.propTypes = {
  children: PropTypes.node,
};

export default BotMarkdown;